import { UserApiService } from 'src/app/user-api.service';
import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-validate-cgu',
  templateUrl: './validate-cgu.component.html',
  styleUrls: ['./validate-cgu.component.scss']
})
export class ValidateCguComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private userApiService: UserApiService) { }

  ngOnInit(): void {
  }


  vlidateCgu(){

    console.log('validateeeeeeee')
    let body = { cgu_ok :true }
    this.userApiService.patchUserDetail(body).subscribe( res => { res } )
  }

}
